<template>
  <div :class="$style.loader">
    <slot>
      <span>Loading...</span>
    </slot>
  </div>
</template>

<style module>
.loader {
  background: var(--bg-page-body);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3rem;
  padding: 1rem;
  overflow: auto;
  @media (min-width: 600px) {
    position: fixed;
    height: 100vh;
    width: 100vw;
    z-index: 99999;
  }
}
</style>
